class cleverDropdown extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.state = that.getAttribute('state');
    that.addEventListener('click', event => {
      if(!!event.target.closest('.dropdown-header')){
        const dropdown_group = that.getAttribute('group');
        let group_dropdowns = [];
        if(!!dropdown_group){
          group_dropdowns = document.querySelectorAll(`clever-dropdown[group=${dropdown_group}]`);
        }
        if(that.state == 'active'){
          that.setAttribute('state', 'inactive');
        } else {
          group_dropdowns.forEach(dropdown => {
            dropdown.setAttribute('state', 'inactive');
          });
          that.setAttribute('state', 'active');
        }
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let that = this;
    that.state = newValue;
  }
}
customElements.define('clever-dropdown', cleverDropdown);

class filterValue extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.state = that.getAttribute('state');
    that.addEventListener('click', event => {
      if(that.state == 'active'){
        that.setAttribute('state', 'inactive');
        that.update();
      } else {
        that.setAttribute('state', 'active');
        that.update();
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let that = this;
    that.state = newValue;
  }
  update(){
    let that = this;
    const section = that.closest('[id^="shopify-section-"]');
    section.classList.add('loading');
    const sectionId = section.querySelector('[data-section-id]').dataset.sectionId;
    const newURL = that.getAttribute('value');
    if(!!newURL){
      history.replaceState(null, "", newURL);
      const sectionApiUrl = newURL.includes('?') ? `${newURL}&section_id=${sectionId}` : `${newURL}?section_id=${sectionId}`;
      that.rerenderSection(section, sectionApiUrl);
    }
  }
  rerenderSection(section, url){
    let that = this;
    fetch(url, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => {
      let template = document.createElement('template');
      template.innerHTML = data.trim();
      let firstChild = template.content.firstChild;
      section.querySelectorAll('clever-dropdown, filter-drawer, filter-collapsible, filter-collapsible-button').forEach(webcomponent => {
        const webcomponent_id = webcomponent.id;
        const webcomponent_target = webcomponent.getAttribute('target');
        let new_webcomponent = null;
        if(!!webcomponent_id){
          new_webcomponent = firstChild.querySelector(`#${webcomponent_id}`);
        }
        if(!!webcomponent_target){
          new_webcomponent = firstChild.querySelector(`[target="${webcomponent_target}"]`);
        }
        if(!!new_webcomponent)
        new_webcomponent.setAttribute('state', webcomponent.getAttribute('state'));
      });
      section.replaceWith(firstChild);
      window.initLazyImages();
      window.dispatchEvent(new Event('collection:rerender'));
    }).catch(function(err) {
      if(!!section)
        section.classList.remove('loading');
      console.error(err);
    });
  
  }

}
customElements.define('filter-value', filterValue);

class sortValue extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.state = that.getAttribute('state');
    that.addEventListener('click', event => {
      const other_sort_values = document.querySelectorAll('sort-value');
      other_sort_values.forEach(sort_value => {
        sort_value.setAttribute('state', 'inactive');
      })
      that.setAttribute('state', 'active');
      that.update();
      const parent_dropdown = that.closest('clever-dropdown');
      if(!!parent_dropdown){
        const parent_dropdown_header = parent_dropdown.querySelector('[data-current-sort-value]');
        if(!!parent_dropdown_header){
          parent_dropdown_header.innerHTML = that.innerHTML;
        }
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let that = this;
    that.state = newValue;
  }
  update(){
    let that = this;
    const section = that.closest('[id^="shopify-section-"]');
    section.classList.add('loading');
    const sectionId = section.querySelector('[data-section-id]').dataset.sectionId;
    const value = that.getAttribute('value');
    if(!!value){
      const current_path = location.pathname;
      let params = (new URL(document.location)).searchParams;
      params.set('sort_by', value);
      const newURL = `${current_path}?${params.toString()}`;
      history.replaceState(null, "", newURL);
      params.set('section_id', sectionId);
      const search = params.toString();
      const sectionApiUrl = `${current_path}?${search}`;
      that.rerenderSection(section, sectionApiUrl);
    }
  }
  rerenderSection(section, url){
    let that = this;
    fetch(url, {
      credentials: 'same-origin',
      headers: {'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    })
    .then(response => response.text())
    .then(data => {
      let template = document.createElement('template');
      template.innerHTML = data.trim();
      let firstChild = template.content.firstChild;
      section.querySelectorAll('clever-dropdown, filter-drawer, filter-collapsible, filter-collapsible-button').forEach(webcomponent => {
        const webcomponent_id = webcomponent.id;
        const webcomponent_target = webcomponent.getAttribute('target');
        let new_webcomponent = null;
        if(!!webcomponent_id){
          new_webcomponent = firstChild.querySelector(`#${webcomponent_id}`);
        }
        if(!!webcomponent_target){
          new_webcomponent = firstChild.querySelector(`[target="${webcomponent_target}"]`);
        }
        if(!!new_webcomponent)
        new_webcomponent.setAttribute('state', webcomponent.getAttribute('state'));
      });
      section.replaceWith(firstChild);
      window.initLazyImages();
      window.dispatchEvent(new Event('collection:rerender'));
    }).catch(function(err) {
      if(!!section)
        section.classList.remove('loading');
      console.error(err);
    });
  }
}
customElements.define('sort-value', sortValue);

class filterDrawer extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.state = that.getAttribute('state');
    that.addEventListener('click', event => {
      if(!event.target.closest('.drawer-wrapper')){
        that.close();
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let that = this;
    that.state = newValue;
  }
  getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const inner = document.createElement('div');
    outer.appendChild(inner);
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }
  open(){
    let that = this;
    that.scrollPos = (document.documentElement.scrollTop || document.body.scrollTop)
    document.body.style.position = 'fixed';
    document.body.style.top = (that.scrollPos * -1)+'px';
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = that.getScrollbarWidth()+'px';
    that.setAttribute('state', 'active');
  }
  close(){
    let that = this;
    document.body.style.position = null;
    document.body.style.top = null;
    document.body.style.overflow = null;
    document.body.style.paddingRight = null;
    document.documentElement.scrollTop = document.body.scrollTop = that.scrollPos;
    that.setAttribute('state', 'inactive');
  }
}
customElements.define('filter-drawer', filterDrawer);

class FilterCollapsible extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.target = that.getAttribute('id');
    that.group = that.getAttribute('group');
  }
  open() {
    let that = this;
    const other_collapsibles = document.querySelectorAll(`filter-collapsible[group="${that.group}"]:not(#${that.target})`);
    other_collapsibles.forEach(collapsible => {
      collapsible.close();
    });
    const buttons = document.querySelectorAll(`filter-collapsible-button[target="${that.target}"]`);
    buttons.forEach(button => {
      button.setAttribute('state', 'active');
    });
    that.setAttribute('state', 'active');
  }
  close() {
    let that = this;
    const buttons = document.querySelectorAll(`filter-collapsible-button[target="${that.target}"]`);
    buttons.forEach(button => {
      button.setAttribute('state', 'inactive');
    });
    that.setAttribute('state', 'inactive');
  }
  toggle() {
    let that = this;
    if(that.getAttribute('state') == 'inactive') {
      that.open();
    } else {
      that.close();
    }
  }
}
customElements.define('filter-collapsible', FilterCollapsible);

class FilterCollapsibleButton extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    that.target = that.getAttribute('target');
    that.addEventListener('click', that.handleClick);
  }
  handleClick(event) {
    const that = this;
    const collapsible = document.querySelector(`filter-collapsible#${that.target}`);
    if(!!collapsible) {
      collapsible.toggle();
    }
  }
}
customElements.define('filter-collapsible-button', FilterCollapsibleButton);

class filterDrawerButton extends HTMLElement {
  static observedAttributes = ["state"];
  constructor() {
    super();
  }
  connectedCallback() {
    let that = this;
    that.state = that.getAttribute('state');
    that.action = that.getAttribute('action');
    that.addEventListener('click', event => {
      const drawer = document.querySelector('filter-drawer');
      if(!!drawer){
        if(that.action == 'open')
          drawer.open();
        else if(that.action == 'close')
          drawer.close();
      }
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    let that = this;
    that.state = newValue;
  }
}
customElements.define('filter-drawer-button', filterDrawerButton);

document.body.addEventListener('click', event => {
  if(!event.target.closest('clever-dropdown')){
    document.querySelectorAll('clever-dropdown').forEach(dropdown => {
      dropdown.setAttribute('state', 'inactive');
    })
  }
});